import * as z from 'zod';
import { AudienceSchema } from '../enums/Audience.schema';
import { EventKindSchema } from '../enums/EventKind.schema';

export const EventSchema = z.object({
  id: z.string(),
  title: z.string().min(1, 'Title is required'),
  eventKind: EventKindSchema.default("STANDARD"),
  description: z.string().min(1, 'Description is required'),
  timezone: z.string().min(1, 'Timezone is required'),
  requiresConsentForm: z.boolean().default(false),
  requiresPhotoConsent: z.boolean().default(false),
  isPublished: z.boolean().default(false),
  isFeatured: z.boolean().default(false),
  isCancelled: z.boolean().default(false),
  isBookable: z.boolean().default(true),
  groupsEnabled: z.boolean().default(false),
  schedule: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  whatToBring: z.string().transform(v => v?.trim() || null).nullable().nullish(),
  location: z.string().max(200).nullish(),
  imageUrl: z.string().nullish(),
  audience: AudienceSchema.default("OPEN"),
  startsAt: z.coerce.date(),
  endsAt: z.coerce.date(),
  bookingClosesAt: z.coerce.date().nullish(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type EventType = z.infer<typeof EventSchema>;
